import React from "react";
import { ThemeProvider } from "./context/ThemeContext";
import "./index.css";
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <ThemeProvider>
      <AppRoutes /> 
    </ThemeProvider>
  );
};

export default App;
